import { Fragment, useState, useEffect } from "react";
import { Menu, Transition } from "@headlessui/react";
import { BellIcon, XIcon } from "@heroicons/react/outline";
import { useDispatch, useSelector } from "react-redux";
import { openPopUp } from "../../redux/actions/notifications";
import formatDate from "../../../utils/helpers";
import { getNotifications } from "../../redux/actions/notifications";
import { Link } from "react-router-dom";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function NotifcationDropdown() {
  const [notifyOpen, setNotifyOpen] = useState(false);
  const [an, setAn] = useState(true);
  const { newNotification, notifications } = useSelector(
    (state) => state.notifications
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (notifyOpen) {
      dispatch(openPopUp());
      setNotifyOpen(false);
      setAn(false);
    }
  }, [dispatch, notifyOpen]);

  useEffect(() => {
    dispatch(getNotifications());
  }, [dispatch]);

  console.log("-----------------------------------------");
  console.log(notifications);
  console.log("-----------------------------------------");

  return (
    <div className="">
      <Menu as="div" className="relative inline-block text-left">
        {({ open }) => (
          <>
            <div>
              <Menu.Button className="w-full px-4 py-2 text-sm font-medium text-white rounded-md ">
                {open ? (
                  <>
                    {/* {notifyOpen && dispatch(openPopUp())} */}
                    {an && setNotifyOpen(true)}
                    <button
                      type="button"
                      className="bg-white p-0.5 text-red-400 border border-red-400 rounded-md hover:text-red-500 "
                    >
                      <span className="sr-only">View notifications</span>
                      <XIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </>
                ) : (
                  <button
                    type="button"
                    className={classNames(
                      newNotification
                        ? "bg-red-50 border border-red-400"
                        : "bg-white border border-gray-400",
                      "p-0.5 text-gray-400 rounded-md hover:text-gray-500 "
                    )}

                    // className="bg-white p-0.5 text-gray-400 border border-gray-400 rounded-md hover:text-gray-500 "
                  >
                    <span className="sr-only">View notifications</span>
                    <BellIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                )}
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 w-72 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="px-1 py-1 ">
                  {notifications !== [] &&
                    notifications
                      .slice(
                        0,
                        notifications.length > 4 ? 4 : notifications.length - 1
                      )
                      .map((notification) => (
                        <Menu.Item>
                          <Link
                            to={`notifications/${notification.id}`}
                            className={classNames(
                              !notification.attributes.isRead
                                ? "bg-red-50 border border-red-400 hover:bg-red-100"
                                : "bg-white border border-gray-400 hover:bg-gray-100",
                              "flex flex-col px-2 py-2 hover:bg-gray-100"
                            )}
                            // className="flex flex-col px-2 py-2 hover:bg-gray-100"
                          >
                            <button className="text-xs text-gray-500 text-left flex rounded-md items-center w-full">
                              {notification.attributes.reason}
                            </button>
                            <span className="text-xs text-gray-400">
                              {formatDate(notification.attributes.createdAt)}
                            </span>
                          </Link>
                        </Menu.Item>
                      ))}
                  {notifications.length === 0 && (
                    <p>there are no notifications</p>
                  )}
                </div>
                <div className="px-2 py-1">
                  <Menu.Item>
                    <button className="mt-2 w-full text-gray-700 py-1 border border-gray-300 rounded-md hover:bg-slate-100">
                      <Link to={`/admin/notifications`}>
                        View all notifications
                      </Link>
                    </button>
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </>
        )}
      </Menu>
    </div>
  );
}
